import { render, staticRenderFns } from "./stepB.vue?vue&type=template&id=0b7a1f7b&scoped=true&"
import script from "./stepB.vue?vue&type=script&lang=js&"
export * from "./stepB.vue?vue&type=script&lang=js&"
import style0 from "./stepB.vue?vue&type=style&index=0&id=0b7a1f7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7a1f7b",
  null
  
)

export default component.exports